import { Card, CardContent } from '@/components/ui/card';
import { Flame, Activity, Copy, Award } from 'lucide-react';

export const SecuritySection = () => {
  const securityFeatures = [
    {
      icon: Flame,
      title: 'Brandschutz',
      description:
        'Integrierte Branderkennungs- und Löschsysteme nach NFPA 855 und VdS-Richtlinien.',
      color: 'text-destructive',
      bgColor: 'bg-destructive/10',
    },
    {
      icon: Activity,
      title: 'BMS-Überwachung',
      description:
        'Echtzeit-Batteriemanagementsystem überwacht Zellzustand, Temperatur und Ladezyklen kontinuierlich.',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      icon: Copy,
      title: 'Redundanz',
      description:
        'N+1-Redundanzkonzepte garantieren Betriebskontinuität auch beim Ausfall einzelner Module.',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
    },
    {
      icon: Award,
      title: 'Zertifizierung',
      description:
        'Alle Systeme sind nach IEC 62619, UL 9540 und CE zertifiziert.',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
    },
  ];

  return (
    <section id="security" className="py-12 sm:py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <p className="text-base sm:text-xl text-muted-foreground font-normal mb-2">
              Sicherheit und Zuverlässigkeit:
            </p>
            <h2 className="font-heading font-bold text-2xl sm:text-4xl lg:text-5xl text-primary mb-6">
              BESS-Lösungen im Fokus
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              Sicherheit ist das Fundament jeder BESS-Installation. Moderne
              Lithium-Ionen- und LFP-Batteriesysteme erfüllen höchste
              Industriestandards und sind mit mehrfachen Schutzschichten
              ausgestattet.
            </p>
          </div>

          {/* Features Grid with Image */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
              {securityFeatures.slice(0, 2).map((feature, index) => (
              <Card
                key={index}
                className="group hover:shadow-lg transition-all duration-300 border-border hover:border-primary/30"
              >
                <CardContent className="p-8 flex flex-col h-full">
                  <div className="flex items-start space-x-4 mb-4">
                    <div
                      className={`w-14 h-14 rounded-xl ${feature.bgColor} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}
                    >
                      <feature.icon className={`w-7 h-7 ${feature.color}`} />
                    </div>
                    <h3 className="font-heading font-semibold text-2xl text-foreground pt-2">
                      {feature.title}
                    </h3>
                  </div>
                  <p className="text-muted-foreground leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            ))}
            </div>
            <img
              src="https://customer-assets.emergentagent.com/job_462b1c9b-939c-4705-8ff2-b6f811719f70/artifacts/5jh4xa40_BatteryRag.jpeg"
              alt="Sicherheitssystem – Detailansicht"
              className="w-full h-full min-h-[200px] md:min-h-[280px] rounded-lg shadow-md object-cover"
              loading="lazy"
              data-testid="security-image"
            />
          </div>

          {/* Remaining Features */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {securityFeatures.slice(2).map((feature, index) => (
              <Card
                key={index}
                className="group hover:shadow-lg transition-all duration-300 border-border hover:border-primary/30"
              >
                <CardContent className="p-8 flex flex-col h-full">
                  {/* Icon & Title Row */}
                  <div className="flex items-start space-x-4 mb-4">
                    <div
                      className={`w-14 h-14 rounded-xl ${feature.bgColor} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}
                    >
                      <feature.icon className={`w-7 h-7 ${feature.color}`} />
                    </div>
                    <h3 className="font-heading font-semibold text-2xl text-foreground pt-2">
                      {feature.title}
                    </h3>
                  </div>

                  {/* Description */}
                  <p className="text-muted-foreground leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};